import RaceRegisterInfoDescription from './RaceRegisterInfoDescription';

export default RaceRegisterInfoDescription;
